import { useEffect } from "react";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { initClarity } from "@/lib/clarity";

/**
 * Consent-gated Microsoft Clarity loader.
 *
 * Reads the analytics-consent state from useCookieConsent (source of truth:
 * localStorage key `cc_cookie_consent`, field `consent.analytics`). Only once
 * analytics consent is granted AND VITE_CLARITY_PROJECT_ID is set does it call
 * initClarity. Reacts to consent changes: when consent flips to true in the
 * same session, the effect re-runs and loads Clarity.
 *
 * If consent is later revoked, saveConsent() triggers a full page reload
 * (see useCookieConsent), so Clarity is not re-injected on the next load.
 *
 * Renders nothing.
 */
export function ClarityLoader() {
  const { consent } = useCookieConsent();

  useEffect(() => {
    const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
    if (consent?.analytics === true && projectId) {
      initClarity(projectId);
    }
  }, [consent?.analytics]);

  return null;
}
